<div class="mobi-ui-wrapper">
  <div class="mobi-ui-wrapper-content">
    <mobi-ui-header-major
      [headerLogo]="MOBI_UI_HEADER_LOGO.MOBILIAR"
      (logoClick)="logoClickHandler()"
    >
      <app-login />
    </mobi-ui-header-major>

    <section class="mobi-ui-section-minor">
      <div class="mobi-ui-container">
        <h1>CIP B2C Demo</h1>
        <ul class="mobi-ui-list-silent is-block">
          <li>
            <a class="mobi-ui-link-block-major" routerLink="/">
              <mobi-ui-icon-major
                class="mobi-ui-link-block-icon-major"
                name="right"
              />
              <span class="mobi-ui-link-block-text-major">Home</span>
            </a>
          </li>
          <li>
            <a class="mobi-ui-link-block-major" routerLink="/protected">
              <mobi-ui-icon-major
                class="mobi-ui-link-block-icon-major"
                name="right"
              />
              <span class="mobi-ui-link-block-text-major">Protected</span>
            </a>
          </li>
          <li>
            <a class="mobi-ui-link-block-major" routerLink="/login">
              <mobi-ui-icon-major
                class="mobi-ui-link-block-icon-major"
                name="right"
              />
              <span class="mobi-ui-link-block-text-major">Login</span>
            </a>
          </li>
        </ul>
      </div>
    </section>
    <router-outlet />
  </div>
  <mobi-ui-footer-major (languageChange)="handleLanguageChange($any($event))">
    <a
      href="https://rwc-ui-components-showcase-rwc-prod-as.azurewebsites.net"
      target="_blank"
      >Showcase</a
    >
  </mobi-ui-footer-major>
</div>
